import { MemberNumberState } from '@bb/users';
import { OnboardingController } from 'api';
import * as React from 'react';
import { useOrgOnboardingContext } from '../../../contexts/OrgOnboardingContext';
import { AgentVerificationPageState } from '../../../types';
import {
  AgentVerificationProps,
  AgentVerificationView as BaseAgentVerificationView,
} from '../../common/AgentVerificationView';

export interface FindMemberViewProps {
  handleGoBackStep: () => void;
}

const FindMemberView: React.FC<FindMemberViewProps> = ({
  handleGoBackStep,
}) => {
  const { orgProfile, orgClaimHash } = useOrgOnboardingContext();

  const claimProfileCall: AgentVerificationProps['claimProfileCall'] =
    async values => {
      let pageState: AgentVerificationPageState;
      const result =
        await OnboardingController.initiateOrgSubmitterClaimProfile({
          boardId: values.boardId,
          number: values.memberId,
          org: orgProfile.id,
          orgClaimHash,
        });

      if (result.state === MemberNumberState.active) {
        pageState = result.inOrg ? 'verificationSent' : 'wrongOrg';
      } else if (result.state === MemberNumberState.deactivated) {
        // This branch might not be possible
        pageState = 'contactOffice';
      } else {
        pageState = 'wrongOrg';
      }
      return { error: '', pageState, result };
    };

  return (
    <BaseAgentVerificationView
      claimProfileCall={claimProfileCall}
      resendVerificationCall={claimProfileCall}
      onRequestStepBack={handleGoBackStep}
    />
  );
};

export default FindMemberView;
